
let firstStepAddBtn = document.querySelectorAll('[data-step-1] [data-add-kit]');
let secondStepAddBtn = document.querySelectorAll('[data-step-2] [data-add-kit]');
let thirdStepAddBtn = document.querySelectorAll('[data-step-3] [data-add-kit]');
let fourthStepAddBtn = document.querySelectorAll('[data-step-4] [data-add-kit]');


let firstPackItems = JSON.parse(localStorage.getItem('firstPackItems')) || [];
let secondPackItems = JSON.parse(localStorage.getItem('secondPackItems')) || [];
let thirdPackItems = JSON.parse(localStorage.getItem('thirdPackItems')) || [];
let fourthPackItems = JSON.parse(localStorage.getItem('fourthPackItems')) || [];

let upsellItems = JSON.parse(localStorage.getItem('upsellItems')) || [];


function closeUpsell(){
 
   document.querySelectorAll('.kit-upsell-box').forEach(modal => {
     modal.style.display = 'none';
  });
}

function closeModal(){
  document.querySelectorAll('#QuickViewModal').forEach(modal => {
     modal.style.display = 'none';
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Get modal elements
  const modal = document.getElementById('QuickViewModal');
  const closeBtn = document.querySelector('.close-quick-view');

  const closeUpsellBtn = document.querySelectorAll('.kit-close-btn');

  // Close modal when clicking on X
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      closeModal();
    });
  }

 

  if (closeUpsellBtn) {
    closeUpsellBtn.forEach((btn) => {
      btn.addEventListener('click', function(event) {
        event.preventDefault();
        closeUpsell();
      });
    });
  }

  document.querySelector('.kit-popup-overlay')?.addEventListener('click', (event) => {
    if (!event.target.closest('.kit-popup-box')) {
      event.preventDefault();
      closeUpsell();
    }
  });



  document.addEventListener('click', function(event) {
    if (event.target.id === 'QuickViewModal') {
      document.querySelectorAll('#QuickViewModal').forEach(modal => {
         closeModal();
      });
    }
  
  });


  // Add event listeners to quick view buttons
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('quick-view-button') || 
        e.target.closest('.quick-view-button')) {
      e.preventDefault();
      const button = e.target.classList.contains('quick-view-button') ? 
                    e.target : e.target.closest('.quick-view-button');
      const productHandle = button.getAttribute('data-product-handle');
      const currentSteps = button.getAttribute('data-current-steps');
      
      loadQuickView(productHandle,currentSteps);
    }
  });

  function buttonEvents(){
    document.querySelectorAll('[data-step-1] .add-to-cart-button').forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        const btn = event.target.closest('.add-to-cart-button');
        if (!btn) return;
  
        btn.classList.add('loading');
  
        const variantId = btn.getAttribute('data-pro-variant');
        const imageSrc = btn.getAttribute('data-pro-image');
        const price = btn.getAttribute('data-pro-price');
  
        const product = {
          id: variantId,
          image_src: imageSrc,
          quantity: 1,
          price: price
        };
  
        firstPackItems.push(product);
        saveFirstPackItems();
        addItem(variantId, btn);
        firstPackFulfill();
      });
    });
    
    document.querySelectorAll('[data-step-2] .add-to-cart-button').forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        const btn = event.target.closest('.add-to-cart-button');
        if (!btn) return;
  
        btn.classList.add('loading');
  
        const variantId = btn.getAttribute('data-pro-variant');
        const imageSrc = btn.getAttribute('data-pro-image');
        const price = btn.getAttribute('data-pro-price');
  
        const product = {
          id: variantId,
          image_src: imageSrc,
          quantity: 1,
          price: price
        };
  
        secondPackItems.push(product);
        saveSecondPackItems();
        addItem(variantId, btn);
        secondPackFulfill();
      });
    });
    document.querySelectorAll('[data-step-3] .add-to-cart-button').forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        const btn = event.target.closest('.add-to-cart-button');
        if (!btn) return;
  
        btn.classList.add('loading');
  
        const variantId = btn.getAttribute('data-pro-variant');
        const imageSrc = btn.getAttribute('data-pro-image');
        const price = btn.getAttribute('data-pro-price');
  
        const product = {
          id: variantId,
          image_src: imageSrc,
          quantity: 1,
          price: price
        };
  
        thirdPackItems.push(product);
        saveThirdPackItems();
        addItem(variantId, btn);
        thirdPackFulfill();
      });
    });

    document.querySelectorAll('[data-step-4] .add-to-cart-button').forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        const btn = event.target.closest('.add-to-cart-button');
        if (!btn) return;
  
        btn.classList.add('loading');
  
        const variantId = btn.getAttribute('data-pro-variant');
        const imageSrc = btn.getAttribute('data-pro-image');
        const price = btn.getAttribute('data-pro-price');
  
        const product = {
          id: variantId,
          image_src: imageSrc,
          quantity: 1,
          price: price
        };
  
        fourthPackItems.push(product);
        saveFourthPackItems();
        addItem(variantId, btn);
        fourthPackFulfill();
      });
    });

    
  }

  function  disblaledButton(currentSteps){

    console.log(currentSteps);
    
     if(firstPackItems.length >= 2){
      const firstBtn = document.querySelector(`[data-step-1] .add-to-cart-button`);
      if (firstBtn) {
        firstBtn.classList.add('disabled');
        firstBtn.disabled = true;
      }
    }
    if(secondPackItems.length > 0){
      const secondBtn = document.querySelector(`[data-step-2] .add-to-cart-button`);
      if (secondBtn) {
        secondBtn.classList.add('disabled');
        secondBtn.disabled = true;
      }
    }
    if(thirdPackItems.length > 0){
      const thirdBtn = document.querySelector(`[data-step-3] .add-to-cart-button`);
      if (thirdBtn) {
        thirdBtn.classList.add('disabled');
        thirdBtn.disabled = true;
      }
    }
    if(fourthPackItems.length > 0){
      const fourthBtn = document.querySelector(`[data-step-4] .add-to-cart-button`);
      if (fourthBtn) {
        fourthBtn.classList.add('disabled');
        fourthBtn.disabled = true;
      }
    }

    
    if(currentSteps == 1 && firstPackItems.length < 2){
      const firstBtn = document.querySelector(`[data-step-1] .add-to-cart-button`);
      if (firstBtn) {
        firstBtn.classList.remove('disabled');
        firstBtn.disabled = false;
      }
    } else if(currentSteps == 2 && firstPackItems.length == 2 && secondPackItems.length < 1){
      const secondBtn = document.querySelector(`[data-step-2] .add-to-cart-button`);
      if (secondBtn) {
        secondBtn.classList.remove('disabled');
        secondBtn.disabled = false;
      }
    } else if(currentSteps == 3 && firstPackItems.length == 2 && secondPackItems.length > 0 && thirdPackItems.length == 0 ){
      const thirdBtn = document.querySelector(`[data-step-3] .add-to-cart-button`);
      if (thirdBtn) {
        thirdBtn.classList.remove('disabled');
        thirdBtn.disabled = false;
      }
    } else if(currentSteps == 4 && firstPackItems.length == 2 && secondPackItems.length > 0 && thirdPackItems.length > 0 && fourthPackItems.length == 0){
      const fourthBtn = document.querySelector(`[data-step-4] .add-to-cart-button`);
      if (fourthBtn) {
        fourthBtn.classList.remove('disabled');
        fourthBtn.disabled = false;
      }
    }
  }

  // Function to load product data using Section Rendering API
  function loadQuickView(handle,currentSteps) {
    if (!handle) return;

    // Show loading state
    modal.style.display = 'flex';
    
    // Use Section Rendering API to fetch the quick-view section with the product data
    const url = `/products/${handle}?section_id=quick-view`;
    
    fetch(url)
      .then(response => response.text())
      .then(html => {
        // Extract the section HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const sectionHtml = doc.querySelector('.quick-view-modal').outerHTML;

        
        // Replace the current quick-view section with the new one
        document.querySelector('.quick-view-modal').outerHTML = sectionHtml;
        
        // Re-assign modal and close button references
        const newModal = document.getElementById('QuickViewModal');
        const newCloseBtn = newModal.querySelector('.close-quick-view');
        newModal.setAttribute(`data-step-${currentSteps}`, '');
        
        // Display the modal
        newModal.style.display = 'flex';
        const swiper = new Swiper('.quick-product-img', {
          slidesPerView: 'auto',
          spaceBetween: 3
        });
        // Setup close button functionality
        if (newCloseBtn) {
          newCloseBtn.addEventListener('click', function() {
            newModal.style.display = 'none';
          });
        }

        disblaledButton(currentSteps);

       

        buttonEvents();
        
        // Initialize any product functionality like variants
        if (typeof refreshVariants === 'function') {
          refreshVariants();
           
        }
      })
      .catch(error => {
        console.error('Quick view error:', error);
        modal.style.display = 'none';
       
        // alert('Error loading product information. Please try again.');
      });
  }
});







document.querySelectorAll('[data-quick-image]').forEach(image => {
  image.addEventListener('click', (event) => {
    event.preventDefault();
    const productCard = image.closest('.card-img'); // Adjust selector to match your markup
    const quickViewButton = productCard?.querySelector('.quick-view-button');
    quickViewButton?.click();
  });
});


function scrollToSteps() {
  // Start by assuming we'll stay on the current step
  let targetStep = 1;
  
  // Check conditions in sequence to find the furthest valid step
  if (firstPackItems.length === 2) {
    targetStep = 2;
    
    if (secondPackItems.length > 0) {
      targetStep = 3;
      
      if (thirdPackItems.length > 0) {
        targetStep = 4;
      }
    }
  }
  
  // Only scroll if we need to move beyond step 1
  if (targetStep > 1) {
    scrollToStep(targetStep);
  }
}

// Generic function to scroll to any step
function scrollToStep(stepNumber) {
  const target = document.querySelector(`[data-step-${stepNumber}]`);
  if (!target) return;
  
  const offset = 100;
  const topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;
  
  window.scrollTo({
    top: topPos,
    behavior: 'smooth'
  });
}

function saveFirstPackItems() {
    localStorage.setItem('firstPackItems', JSON.stringify(firstPackItems));
}

function saveSecondPackItems() {
    localStorage.setItem('secondPackItems', JSON.stringify(secondPackItems));
}

function saveThirdPackItems() {
    localStorage.setItem('thirdPackItems', JSON.stringify(thirdPackItems));
}

function saveFourthPackItems() {
    localStorage.setItem('fourthPackItems', JSON.stringify(fourthPackItems));
}

function scrollToStep2() {
  const target = document.querySelector('[data-step-2]');
  const offset = 100;
  const topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top: topPos,
    behavior: 'smooth'
  });
}

function scrollToStep3() {
  const target = document.querySelector('[data-step-3]');
  const offset = 100;
  const topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top: topPos,
    behavior: 'smooth'
  });
}

function scrollToStep4() {
  const target = document.querySelector('[data-step-4]');
  const offset = 100;
  const topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top: topPos,
    behavior: 'smooth'
  });
}

function stepsFulfill(mergedItems){
 
  let progressItems = document.querySelectorAll('[data-summary-progress] .progress-item');
  progressItems.forEach(item => item.classList.remove('active'));
  for (let i = 0; i < mergedItems.length && i < progressItems.length; i++) {
      progressItems[i].classList.add('active');
  }
          
}


// Function to handle fulfillment state
function firstPackFulfill() {
  const firstPackLength = firstPackItems.length;
  firstStepAddBtn.forEach((btn) => {
    if (firstPackLength >= 2) {
      btn.classList.add('disabled');
      btn.disabled = true;
    } else if(firstPackLength == 1){
      btn.classList.remove('disabled');
      btn.disabled = false;
    }
  });
  if (firstPackLength >= 2) {
    secondStepAddBtn.forEach((btn) => {
        btn.classList.remove('disabled');
        btn.disabled = false;
    });
  } else if(firstPackLength == 1){
    secondStepAddBtn.forEach((btn) => {
        btn.classList.add('disabled');
        btn.disabled = true;
    });
    
  }
}

// Function to handle fulfillment state
function secondPackFulfill() {
  const secondPackLength = secondPackItems.length;
  secondStepAddBtn.forEach((btn) => {
    if (secondPackLength >= 1) {
      btn.classList.add('disabled');
      btn.disabled = true;
    } 
  });
  if (secondPackLength >= 1) {
    thirdStepAddBtn.forEach((btn) => {
        btn.classList.remove('disabled');
        btn.disabled = false;
    });
  }

  
}

// Function to handle fulfillment state
function thirdPackFulfill() {
  const thirdPackLength = thirdPackItems.length;
  thirdStepAddBtn.forEach((btn) => {
    if (thirdPackLength >= 1) {
      btn.classList.add('disabled');
      btn.disabled = true;
    }
  });
  if (thirdPackLength >= 1) {
    fourthStepAddBtn.forEach((btn) => {
        btn.classList.remove('disabled');
        btn.disabled = false;
    });
  }
}

// Function to handle fulfillment state
function fourthPackFulfill() {
  const fourthPackLength = fourthPackItems.length;
  fourthStepAddBtn.forEach((btn) => {
    if (fourthPackLength >= 1) {
      btn.classList.add('disabled');
      btn.disabled = true;
    } 
  });
}

function setKitTotal(mergedItems){
 
  let totalPrice = 0;
  let comparePrice = 0;
  mergedItems.forEach((item)=> {
    let productPrice = parseInt(item.price)
    totalPrice += productPrice;
  });

  if(mergedItems.length < 5){
    let leftCount = 5 - mergedItems.length;
    document.querySelector('[data-set-offer] [data-set-left]').textContent = `${leftCount} Products`;
    document.querySelector('[data-set-offer]').classList.remove('hide');
    document.querySelector('[data-got-offer]').classList.add('hide');
  } 

  if(mergedItems.length == 5){
    // document.querySelector('[data-pack-price-total]').innerHTML = `$${((totalPrice * 0.7) / 100).toFixed(2)}`;
    // document.querySelector('[data-pack-compare-price]').innerHTML = `$${(totalPrice / 100).toFixed(2)}`;
    // document.querySelector('[data-pack-compare-price]').classList.remove('hidden');
    let checkoutBtns = document.querySelectorAll('[data-checkout-pack]');
    checkoutBtns.forEach((btn) => {
      btn.disabled = false;
      btn.classList.remove('disabled');
    });
    

    document.querySelector('.kit-popup')?.classList.add('open');
    document.querySelector('.mobile-kit-popup-box')?.classList.add('open');

     document.querySelector('[data-set-offer]').classList.add('hide');
    document.querySelector('[data-got-offer]').classList.remove('hide');
    
  } else {
    // document.querySelector('[data-pack-price-total]').innerHTML = `$${(totalPrice / 100).toFixed(2)}`;
    // document.querySelector('[data-pack-compare-price]').classList.add('hidden');
    let checkoutBtns = document.querySelectorAll('[data-checkout-pack]');
    checkoutBtns.forEach((btn) => {
      btn.disabled = true;
      btn.classList.add('disabled');
    });
  }

  let totalCount = upsellItems.length + mergedItems.length;

  document.querySelector('[data-set-count]').textContent  = totalCount;

  
}

function getCartData() {
  return fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .catch((error) => {
    console.error('Error fetching cart data:', error);
  });
}

loadKitItems();



async function loadKitItems(){
  let cartData = await getCartData();
  let cartItems = cartData.items;

  let filteredFirstPackItems = firstPackItems.filter(firstItem => 
    cartItems.some(cartItem => cartItem.id === parseInt(firstItem.id))
  );
  let filteredSecondPackItems = secondPackItems.filter(secondItem => 
    cartItems.some(cartItem => cartItem.id === parseInt(secondItem.id))
  );
  let filteredThirdPackItems = thirdPackItems.filter(thirdItem => 
    cartItems.some(cartItem => cartItem.id === parseInt(thirdItem.id))
  );
  let filteredFourthPackItems = fourthPackItems.filter(fourthItem => 
    cartItems.some(cartItem => cartItem.id === parseInt(fourthItem.id))
  );

  let filteredUpsellItems = upsellItems.filter(upsellItem => 
    cartItems.some(cartItem => cartItem.id === parseInt(upsellItem.id))
  );
  
  firstPackItems = filteredFirstPackItems;
  secondPackItems = filteredSecondPackItems;
  thirdPackItems = filteredThirdPackItems;
  fourthPackItems = filteredFourthPackItems;
  upsellItems = filteredUpsellItems;
  
  
  saveFirstPackItems();
  saveSecondPackItems();
  saveThirdPackItems();
  saveFourthPackItems();

  saveUpsellItems();

  checkFirstSet();
  
  firstProductSelection(firstPackItems);
  secondProductSelection(secondPackItems);
  thirdProductSelection(thirdPackItems);
  fourthProductSelection(fourthPackItems);
  firstPackFulfill();
  secondPackFulfill();
  thirdPackFulfill();
  fourthPackFulfill();

  
  
  const mergedItems = [
    ...firstPackItems,
    ...secondPackItems,
    ...thirdPackItems,
    ...fourthPackItems
  ];
  setKitTotal(mergedItems);
  
  let html = await buildResultHTML();
  document.querySelector('[data-result-listing]').innerHTML = html;
  closeModal();

  scrollToSteps();
  
  
  stepsFulfill(mergedItems);

  

  
  

  
}


document.body.addEventListener('click', async (event) => {
    if (event.target.closest('.close-icon')) { 
        const button = event.target.closest('.close-icon');
        let variantID = button.getAttribute('data-remove-pack');
        
        let cartData = await getCartData();
        let cartItems = cartData.items;

        // Find the cartItem that matches the variantID
        const cartItem = cartItems.find(item => item.id === parseInt(variantID));

        // Check the quantity of the matched cartItem
        if (cartItem) {
            if (cartItem.quantity > 1) {
                // If quantity is more than 1, remove one item
                let leftqty = cartItem.quantity - 1;
                removeItem(variantID, leftqty);
            } else {
                // If quantity is 1 or less, remove zero items (or whatever your logic is)
                removeItem(variantID, 0);
            }
        }

        // Remove item from firstPackItems array
        const firstIndex = firstPackItems.findIndex(item => item.id === variantID);
        if (firstIndex !== -1) {
            // Remove the item at the found index
            firstPackItems.splice(firstIndex, 1);

            // Save updated array to localStorage
            localStorage.setItem('firstPackItems', JSON.stringify(firstPackItems));

            
        }
      
        const secondIndex = secondPackItems.findIndex(item => item.id === variantID);
        if (secondIndex !== -1) {
            // Remove the item at the found index
            secondPackItems.splice(firstIndex, 1);

            // Save updated array to localStorage
            localStorage.setItem('secondPackItems', JSON.stringify(secondPackItems));

           
        }
        const thirdIndex = thirdPackItems.findIndex(item => item.id === variantID);
        if (thirdIndex !== -1) {
            // Remove the item at the found index
            thirdPackItems.splice(firstIndex, 1);

            // Save updated array to localStorage
            localStorage.setItem('thirdPackItems', JSON.stringify(thirdPackItems));

           
        }
        const fourthIndex = fourthPackItems.findIndex(item => item.id === variantID);
        if (fourthIndex !== -1) {
            // Remove the item at the found index
            fourthPackItems.splice(firstIndex, 1);

            // Save updated array to localStorage
            localStorage.setItem('fourthPackItems', JSON.stringify(fourthPackItems));

           
        }

        // Re-render selectionHTML to update the UI
        loadKitItems();
    }
});



function firstProductSelection(firstPackItems){
  if(firstPackItems.length > 1){
   firstPackItems.forEach((item) => {
     
      firstStepAddBtn.forEach((btn) => {
          let productVarID = btn.getAttribute('data-pro-variant'); 
            if(item.id == productVarID){
              //btn.querySelector('.add-text').textContent = 'Added';
              btn.disabled = true;
              btn.classList.add('added'); 
            } 
      });
     
   });
  } else if(firstPackItems.length == 1){
    firstPackItems.forEach((item) => {
      firstStepAddBtn.forEach((btn) => {
          let productVarID = btn.getAttribute('data-pro-variant'); 
          if(item.id == productVarID && firstPackItems.length < 2){
            //btn.querySelector('.add-text').textContent = 'Added';
            btn.disabled = true;
            btn.classList.add('added'); 
          } else {
            //btn.querySelector('.add-text').textContent = 'Add to kit';
            btn.disabled = false;
            btn.classList.remove('added'); 
          }
      });
    });
    
  } else {
      firstStepAddBtn.forEach((btn) => {  
        //btn.querySelector('.add-text').textContent = 'Add to kit';
        btn.classList.remove('added');  
      });
  }
}

function secondProductSelection(secondPackItems){
  if(secondPackItems.length > 0){
   secondPackItems.forEach((item) => {
     
       secondStepAddBtn.forEach((btn) => {
          let productVarID = btn.getAttribute('data-pro-variant'); 
            if(item.id == productVarID){
              //btn.querySelector('.add-text').textContent = 'Added';
              btn.disabled = true;
              btn.classList.add('added'); 
            } 
      });
     
   });
  } else {
      secondStepAddBtn.forEach((btn) => {  
        //btn.querySelector('.add-text').textContent = 'Add to kit';
        btn.classList.remove('added');  
      });
  }
}

function thirdProductSelection(thirdPackItems){
  if(thirdPackItems.length > 0){
   thirdPackItems.forEach((item) => {
     
       thirdStepAddBtn.forEach((btn) => {
          let productVarID = btn.getAttribute('data-pro-variant'); 
            if(item.id == productVarID){
              //btn.querySelector('.add-text').textContent = 'Added';
              btn.disabled = true;
              btn.classList.add('added'); 
            } 
      });
     
   });
  } else {
      thirdStepAddBtn.forEach((btn) => {  
        //btn.querySelector('.add-text').textContent = 'Add to kit';
        btn.classList.remove('added');  
      });
  }
}

function fourthProductSelection(fourthPackItems){
  if(fourthPackItems.length > 0){
   fourthPackItems.forEach((item) => {
     
       fourthStepAddBtn.forEach((btn) => {
          let productVarID = btn.getAttribute('data-pro-variant'); 
            if(item.id == productVarID){
              //btn.querySelector('.add-text').textContent = 'Added';
              btn.disabled = true;
              btn.classList.add('added'); 
            } 
      });
     
   });
  } else {
      fourthStepAddBtn.forEach((btn) => {  
        //btn.querySelector('.add-text').textContent = 'Add to kit';
        btn.classList.remove('added');  
      });
  }
}



function buildResultHTML(){
  let selectedProductHTML = '';
  if(firstPackItems.length == 0){
    selectedProductHTML += `
        <div class="col-4">
            <div class="pro-image-wrapper">
                 <div class="svg-image" data-selected-item-image>
                     <svg width="70" height="84" viewBox="0 0 70 84" fill="none">
                        <path d="M68.2477 1.58447C60.0792 0.59078 43.7422 2.77689 43.7422 19.4708C43.7422 40.3382 62.6508 31.8211 67.6427 50.985" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                        <path d="M34.8174 1.37146H68.0965V49.4942C68.0965 64.1866 65.2667 82.4988 34.8174 82.4988" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                        <path d="M1.38702 1.58447C9.55554 0.59078 25.8926 2.77689 25.8926 19.4708C25.8926 40.3382 6.98397 31.8211 1.9921 50.985" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                        <path d="M34.8174 1.37146H1.53823V49.4942C1.53823 64.1866 4.36802 82.4988 34.8174 82.4988" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                      </svg>
                </div>
            </div>
        </div>
         <div class="col-4">
            <div class="pro-image-wrapper">
                 <div class="svg-image" data-selected-item-image>
                     <svg width="70" height="84" viewBox="0 0 70 84" fill="none">
                        <path d="M68.2477 1.58447C60.0792 0.59078 43.7422 2.77689 43.7422 19.4708C43.7422 40.3382 62.6508 31.8211 67.6427 50.985" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                        <path d="M34.8174 1.37146H68.0965V49.4942C68.0965 64.1866 65.2667 82.4988 34.8174 82.4988" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                        <path d="M1.38702 1.58447C9.55554 0.59078 25.8926 2.77689 25.8926 19.4708C25.8926 40.3382 6.98397 31.8211 1.9921 50.985" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                        <path d="M34.8174 1.37146H1.53823V49.4942C1.53823 64.1866 4.36802 82.4988 34.8174 82.4988" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                      </svg>
                </div>
            </div>
        </div>
    `;
  }else if(firstPackItems.length > 1){
    firstPackItems.forEach((item) => {
      selectedProductHTML += `
          <div class="col-4">
              <div class="pro-image-wrapper">
                  <span class="close-icon" data-remove-pack="${item.id}">
                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                        <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                      </svg>
                  </span>
                 
                  <div data-selected-item-image>
                      <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                  </div>
              </div>
          </div>
      `;
    });
  } else {
    firstPackItems.forEach((item) => {
      selectedProductHTML += `
          <div class="col-4">
              <div class="pro-image-wrapper">
                  <span class="close-icon" data-remove-pack="${item.id}">
                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                        <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                      </svg>
                  </span>
                 
                  <div data-selected-item-image>
                      <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                  </div>
              </div>
          </div>
          <div class="col-4">
            <div class="pro-image-wrapper">
                 <div class="svg-image" data-selected-item-image>
                     <svg width="70" height="84" viewBox="0 0 70 84" fill="none">
                        <path d="M68.2477 1.58447C60.0792 0.59078 43.7422 2.77689 43.7422 19.4708C43.7422 40.3382 62.6508 31.8211 67.6427 50.985" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                        <path d="M34.8174 1.37146H68.0965V49.4942C68.0965 64.1866 65.2667 82.4988 34.8174 82.4988" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                        <path d="M1.38702 1.58447C9.55554 0.59078 25.8926 2.77689 25.8926 19.4708C25.8926 40.3382 6.98397 31.8211 1.9921 50.985" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                        <path d="M34.8174 1.37146H1.53823V49.4942C1.53823 64.1866 4.36802 82.4988 34.8174 82.4988" stroke="#9F9084" stroke-width="2.12933" stroke-dasharray="4.68 4.68"/>
                      </svg>
                </div>
            </div>
        </div>
      `;
    });
  }
  

  
  if(secondPackItems.length > 0){
    secondPackItems.forEach((item) => {
       selectedProductHTML += `
          <div class="col-4">
              <div class="pro-image-wrapper">
                  <span class="close-icon" data-remove-pack="${item.id}">
                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                        <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                      </svg>
                  </span>
                 
                  <div data-selected-item-image>
                      <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                  </div>
              </div>
          </div>
      `;
    });
  } else {
     selectedProductHTML += `
        <div class="col-4">
            <div class="pro-image-wrapper">
                <div class="svg-image" data-selected-item-image>
                   <svg width="70" height="79" viewBox="0 0 70 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 71.5V7C1 3.68629 3.68629 1 7 1H43.5147C45.106 1 46.6321 1.63214 47.7574 2.75736L67.2426 22.2426C68.3679 23.3679 69 24.894 69 26.4853V71.5C69 74.8137 66.3137 77.5 63 77.5H7C3.68629 77.5 1 74.8137 1 71.5Z" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="6 4"/>
                    <path d="M45 2V18C45 21.3137 47.6863 24 51 24H68.5" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="6 4"/>
                    </svg>
                </div>
            </div>
        </div>
    `;
  }

  
  if(thirdPackItems.length > 0){
    thirdPackItems.forEach((item) => {
      selectedProductHTML += `
        <div class="col-4">
            <div class="pro-image-wrapper">
                <span class="close-icon" data-remove-pack="${item.id}">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                      <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                      <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                    </svg>
                </span>
               
                <div data-selected-item-image>
                    <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                </div>
            </div>
        </div>
    `;
    });
  } else {
     selectedProductHTML += `
        <div class="col-4">
            <div class="pro-image-wrapper">
                <div class="svg-image" data-selected-item-image>
                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                      <path d="M24.8896 58.9303C25.1336 64.6718 26.098 70.15 29.8368 73.8889C35.13 79.182 43.9095 78.9143 51.9867 78.9143C60.0639 78.9143 68.8434 79.182 74.1365 73.8889C79.4297 68.5957 79.162 59.8162 79.162 51.739C79.162 43.6618 79.4297 34.8823 74.1365 29.5891C68.8434 24.296 60.0639 24.5637 51.9867 24.5637C43.9095 24.5637 35.13 24.296 29.8368 29.5891C26.1043 33.3216 25.1369 38.7875 24.8909 44.5185" stroke="#9F9084" stroke-width="1.6875" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3.38 3.38"/>
                      <path d="M26.5296 69.0623C24.851 68.3456 23.3244 67.3759 22.0113 66.0628C16.7178 60.7693 16.9852 51.9892 16.9852 43.9129C16.9852 35.8351 16.7178 27.0549 22.0113 21.763C27.3032 16.4696 36.0833 16.7369 44.1611 16.7369C52.2374 16.7369 61.0175 16.4696 66.311 21.763C67.6225 23.0745 68.5923 24.5996 69.3089 26.275" stroke="#9F9084" stroke-width="1.6875" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3.38 3.38"/>
                      <path d="M18.7034 61.236C17.0249 60.5194 15.4966 59.548 14.1836 58.2349C8.89008 52.943 9.15903 44.1629 9.15903 36.0851C9.15903 28.0088 8.89008 19.2287 14.1836 13.9352C19.477 8.64173 28.2571 8.91067 36.3334 8.91067C44.4113 8.91067 53.1914 8.64173 58.4833 13.9352C59.7948 15.2467 60.7646 16.7734 61.4828 18.4487" stroke="#9F9084" stroke-width="1.6875" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3.38 3.38"/>
                      <path d="M10.8773 53.4098C9.19879 52.6932 7.67055 51.7218 6.35747 50.4087C1.06399 45.1152 1.33135 36.3367 1.33135 28.2589C1.33135 20.1826 1.06399 11.4025 6.35747 6.10899C11.6509 0.815515 20.4311 1.08288 28.5073 1.08288C36.5852 1.08288 45.3637 0.815515 50.6572 6.10899C51.9687 7.4205 52.9385 8.94716 53.6567 10.6225" stroke="#9F9084" stroke-width="1.6875" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3.38 3.38"/>
                      <path d="M66.7225 37.0172C63.2044 33.4991 57.3692 33.6771 52.0009 33.6771C46.6326 33.6771 40.7974 33.4991 37.2793 37.0172C34.7985 39.498 34.1556 43.1308 33.992 46.9397L33.9912 56.5185C34.1534 60.3345 34.7942 63.9755 37.2793 66.4604C40.7974 69.9785 46.6326 69.8006 52.0009 69.8006C57.3692 69.8006 63.2044 69.9785 66.7225 66.4604C70.2406 62.9423 70.0626 57.1071 70.0626 51.7388C70.0626 46.3705 70.2405 40.5354 66.7225 37.0172Z" stroke="#9F9084" stroke-width="1.6875" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3.38 3.38"/>
                    </svg>
                </div>
            </div>
        </div>
    `;
  }

  if(fourthPackItems.length > 0){
    fourthPackItems.forEach((item) => {
     selectedProductHTML += `
        <div class="col-4">
            <div class="pro-image-wrapper">
                <span class="close-icon" data-remove-pack="${item.id}">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                      <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                      <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                    </svg>
                </span>
               
                <div data-selected-item-image>
                    <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                </div>
            </div>
        </div>
    `;
    });
  } else {
     selectedProductHTML += `
        <div class="col-4">
            <div class="pro-image-wrapper">
                <div class="svg-image" data-selected-item-image>
                    <svg width="64" height="84" viewBox="0 0 64 84" fill="none">
                        <path d="M54.6921 8.45273C61.9533 35.4255 60.9985 52.7626 62.7471 81.7853C37.607 82.9462 24.7562 82.5014 1.74707 81.7853C3.79353 50.8692 4.67644 33.5738 14.6647 1.49878C18.6366 2.31365 22.1416 2.89751 25.4294 3.26089M54.6921 8.45273C54.0872 6.20572 53.4253 3.89185 52.7 1.49878C47.2521 2.54904 42.6825 3.23886 38.3471 3.54105M54.6921 8.45273L62.7471 5.92402M38.3471 3.54105C41.5898 12.4856 42.9926 17.2738 42.653 24.2571M38.3471 3.54105C36.4057 3.67637 34.5112 3.73396 32.6059 3.71138M32.6059 3.71138C33.7272 9.76446 34.3002 13.1577 34.0412 19.1997M32.6059 3.71138C30.2659 3.68365 27.9094 3.53499 25.4294 3.26089M25.4294 3.26089C21.1405 13.4882 20.5477 19.331 22.5588 29.9467" stroke="#9F9084" stroke-width="2" stroke-linecap="round" stroke-dasharray="4 4"/>
                    </svg>
                </div>
            </div>
        </div>
    `;
    
  }

  return selectedProductHTML;

  
}

// const addMinusSetBtns = document.querySelectorAll('[data-qty-set-minus]');
// const addPlusSetBtns = document.querySelectorAll('[data-qty-set-plus]');

// addPlusSetBtns.forEach(btn => {
//   btn.addEventListener('click', (event) => {
//     event.preventDefault();
//     let variantId = btn.closest('[data-add-kit]').getAttribute('data-pro-variant'); 
//     let button = event.target.closest('button');
//     addItem(variantId, button);
//   });
// });

// addMinusSetBtns.forEach(btn => {
//   btn.addEventListener('click', (event) => {
//     event.preventDefault();
    
//     let variantId = btn.closest('[data-add-kit]').getAttribute('data-pro-variant'); 
//     let button = event.target.closest('button');
//     removeItem(variantId, button);
//   });
// });

let qtyChangeSetBtn = document.querySelectorAll('[data-qty-btn-set]');
let qtySetInputs = document.querySelectorAll('[data-qty-input-set]');

qtyChangeSetBtn.forEach((button) => {
    button.addEventListener('click', (event) => {
        manageSetQtyBtn(event)
        let inputs = document.querySelectorAll('.card-kit [data-qty-container-set] a');
        inputs.forEach(input => {
            input.classList.add('disabled'); 
            input.disabled = true;
        });

      setTimeout(() => {
        inputs.forEach(input => {
            input.classList.remove('disabled'); 
            input.disabled = false;
        });
      },2500)
    
    });
});

qtySetInputs.forEach((input) => {
    input.addEventListener('click', (event) => {
        event.preventDefault();

        if (input.value === 'ADD TO KIT') {
            // Find the associated increase button
            const increaseButton = input.closest('[data-qty-container-set]').querySelector('[data-increase-qty]');
            if (increaseButton) {
                // Directly call the click method instead of dispatching a synthetic event
                increaseButton.click();
            }
        }
    });
});


function manageSetQtyBtn(event){
    event.preventDefault();
    let currentTarget = event.currentTarget;
   
    let action = currentTarget.dataset.for;
    if(action == 'increase' && firstPackItems.length >= 2){
      return false;
    }
    let button = currentTarget.closest('[data-qty-container-set]');
    let $qtyInput = currentTarget.closest('[data-qty-container-set]').querySelector('[data-qty-input-set]');
    let qtyInputVal = parseInt($qtyInput.value);
    let currentQty = 0;
    if (!isNaN(qtyInputVal)) {
        currentQty = qtyInputVal;
    }

 
    //let currentQty = parseInt($qtyInput.value) || 0;
    let finalQty = currentQty || 1;
    let variantID = currentTarget.closest('[data-qty-container-set]').getAttribute('data-pro-variant');
    let imageSrc = currentTarget.closest('[data-qty-container-set]').getAttribute('data-pro-image');
    let price = currentTarget.closest('[data-qty-container-set]').getAttribute('data-pro-price');

 
    if(action == 'decrease'){
      finalQty = currentQty - 1;
      removeItem(variantID,finalQty)
      removeFirstProductById(variantID);
    } else {
      finalQty = currentQty + 1;
     
      const product = {
        id: variantID,
        image_src: imageSrc,
        quantity: 1,
        price:price
      };
  
      firstPackItems.push(product);
      saveFirstPackItems();
      addFirstSetItem(variantID,button);
    
      firstPackFulfill();
      
    }

    if(finalQty < 1){
      $qtyInput.value = 'ADD TO KIT';
    } else {
      $qtyInput.value = finalQty;
    }

   
  
}

function removeFirstProductById(id) {
    const index = firstPackItems.findIndex(item => item.id === id);
    if (index !== -1) {
        firstPackItems.splice(index, 1);
    }
    saveFirstPackItems();
    loadKitItems();
}


async function checkFirstSet() {
  // let cartData = await getCartData();
  // let cartItems = cartData.items;

  document.querySelectorAll('[data-qty-container-set]')?.forEach((container) => {
    const variantID = container.getAttribute('data-pro-variant');
    const qtyInput = container.querySelector('[data-qty-input-set]');

    let quantity = 0;
    firstPackItems.forEach((item) => {
      if (item.id == variantID) {
        quantity += item.quantity;
      }
    });

   

   
    if (quantity > 0) {
        // Set the quantity input value to the count
        qtyInput.value = quantity;
    } else {
        // If no matching item, default to 'ADD'
        qtyInput.value = 'ADD TO KIT';
    }

  });
  

}


// Attach click listeners
// firstStepAddBtn.forEach((btn) => {
//   btn.addEventListener('click', (event) => {
//     event.preventDefault();
//     btn.classList.add('loading');
//     const variantId = btn.getAttribute('data-pro-variant'); 
//     const imageSrc = btn.getAttribute('data-pro-image');

//     const price = btn.getAttribute('data-pro-price')

//     const product = {
//       id: variantId,
//       image_src: imageSrc,
//       quantity: 1,
//       price:price
//     };

//     firstPackItems.push(product);
//     saveFirstPackItems();
//     addItem(variantId, btn);
//     firstPackFulfill();
    
//   });
// });




// Attach click listeners
secondStepAddBtn.forEach((btn) => {
  btn.addEventListener('click', (event) => {
    event.preventDefault();
    btn.classList.add('loading');
    const variantId = btn.getAttribute('data-pro-variant'); 
    const imageSrc = btn.getAttribute('data-pro-image');
    const price = btn.getAttribute('data-pro-price')

    const product = {
      id: variantId,
      image_src: imageSrc,
      quantity: 1,
      price:price
    };

    secondPackItems.push(product);
    saveSecondPackItems();
    addItem(variantId, btn);
    secondPackFulfill();
    
  });
});

// Attach click listeners
thirdStepAddBtn.forEach((btn) => {
  btn.addEventListener('click', (event) => {
    event.preventDefault();
    btn.classList.add('loading');
    const variantId = btn.getAttribute('data-pro-variant'); 
    const imageSrc = btn.getAttribute('data-pro-image');

    const price = btn.getAttribute('data-pro-price')

    const product = {
      id: variantId,
      image_src: imageSrc,
      quantity: 1,
      price:price
    };

    thirdPackItems.push(product);
    saveThirdPackItems();
    addItem(variantId, btn);
    thirdPackFulfill();
    
  });
});

// Attach click listeners
fourthStepAddBtn.forEach((btn) => {
  btn.addEventListener('click', (event) => {
    event.preventDefault();
    btn.classList.add('loading');
    const variantId = btn.getAttribute('data-pro-variant'); 
    const imageSrc = btn.getAttribute('data-pro-image');

    const price = btn.getAttribute('data-pro-price')

    const product = {
      id: variantId,
      image_src: imageSrc,
      quantity: 1,
      price:price
    };

    fourthPackItems.push(product);
    saveFourthPackItems();
    addItem(variantId, btn);
    fourthPackFulfill();
    
  });
});

// const addUpsellBtns = document.querySelectorAll('[data-add-kit-upsell]');

// addUpsellBtns.forEach(btn => {
//   btn.addEventListener('click', (event) => {
//     event.preventDefault();
//     btn.classList.add('loading');
//     let variantId = btn.getAttribute('data-pro-variant'); 
//     addUpsellItem(variantId, btn);
//   });
// });

// const addMinusBtns = document.querySelectorAll('[data-qty-upsell-minus]');
// const addPlusBtns = document.querySelectorAll('[data-qty-upsell-plus]');

let qtyChangeUpsellBtn = document.querySelectorAll('[data-qty-btn-upsell]');
let qtyUpsellInputs = document.querySelectorAll('[data-qty-input-upsell]');

qtyChangeUpsellBtn.forEach((button) => {
    button.addEventListener('click', (event) => {
        manageUpsellQtyBtn(event)
        let inputs = event.target.closest('.kit-upsell-box').querySelectorAll('[data-qty-container-upsell] a');
        inputs.forEach(input => {
            input.classList.add('disabled'); 
            input.disabled = true;
        });

      setTimeout(() => {
        inputs.forEach(input => {
            input.classList.remove('disabled'); 
            input.disabled = false;
        });
      },2500)
    
    });
});

qtyUpsellInputs.forEach((input) => {
    input.addEventListener('click', (event) => {
        event.preventDefault();

        if (input.value === 'ADD TO KIT') {
            // Find the associated increase button
            const increaseButton = input.closest('[data-qty-container-upsell]').querySelector('[data-increase-qty]');
            if (increaseButton) {
                // Directly call the click method instead of dispatching a synthetic event
                increaseButton.click();
            }
        }
    });
});


function saveUpsellItems() {
    localStorage.setItem('upsellItems', JSON.stringify(upsellItems));
}

function removeUpsellById(id){
    const index = upsellItems.findIndex(item => item.id === id);
    if (index !== -1) {
        upsellItems.splice(index, 1);
    }
    saveUpsellItems();
    loadKitItems();
}

function manageUpsellQtyBtn(event){
     event.preventDefault();
    let currentTarget = event.currentTarget;
   
    let action = currentTarget.dataset.for;
    let $qtyInput = currentTarget.closest('[data-qty-container-upsell]').querySelector('[data-qty-input-upsell]');
    let qtyInputVal = parseInt($qtyInput.value);
    let currentQty = 0;
    if (!isNaN(qtyInputVal)) {
        currentQty = qtyInputVal;
    }

 
    //let currentQty = parseInt($qtyInput.value) || 0;
    let finalQty = currentQty || 1;
    let variantID = currentTarget.closest('[data-qty-container-upsell]').getAttribute('data-pro-variant');

 
    if(action == 'decrease'){
      finalQty = currentQty - 1;
      removeUpsellItem(variantID,finalQty)
      removeUpsellById(variantID);
    } else {
      finalQty = currentQty + 1;
       const product = {
        id: variantID,
        quantity:1
      };
  
      upsellItems.push(product);
      saveUpsellItems();
      
      addUpsellItem(variantID,1);

    }

    if(finalQty < 1){
      $qtyInput.value = 'ADD TO KIT';
      $qtyInput.closest('[data-qty-container-upsell]').classList.remove('added')
    } else {
      $qtyInput.value = finalQty;
      $qtyInput.closest('[data-qty-container-upsell]').classList.add('added')
    }
  
}



// addPlusBtns.forEach(btn => {
//   btn.addEventListener('click', (event) => {
//     event.preventDefault();
    
//     let variantId = btn.closest('[data-add-kit-upsell]').getAttribute('data-pro-variant'); 
//     let button = event.target.closest('button');
//     addUpsellItem(variantId, button);
//   });
// });

// addMinusBtns.forEach(btn => {
//   btn.addEventListener('click', (event) => {
//     event.preventDefault();
    
//     let variantId = btn.closest('[data-add-kit-upsell]').getAttribute('data-pro-variant'); 
//     let button = event.target.closest('button');
//     removeUpsellItem(variantId, button);
//   });
// });
checkUpsell();
async function checkUpsell() {
  // let cartData = await getCartData();
  // let cartItems = cartData.items;

  document.querySelectorAll('[data-qty-container-upsell]')?.forEach((container) => {
    const variantID = container.getAttribute('data-pro-variant');
    const qtyInput = container.querySelector('[data-qty-input-upsell]');
  
    let quantity = 0;
   
    upsellItems.forEach((item) => {
      if (item.id == variantID) {
        quantity += item.quantity;
      }
    });


   
    if (quantity > 0) {
        // Set the quantity input value to the count
        qtyInput.value = quantity;
        qtyInput.closest('[data-qty-container-upsell]').classList.add('added')
    } else {
        // If no matching item, default to 'ADD'
        qtyInput.value = 'ADD TO KIT';
       qtyInput.closest('[data-qty-container-upsell]').classList.remove('added')
    }

  });

 
  
  // addUpsellBtns.forEach(btn => {
  //   let varID = btn.getAttribute('data-pro-variant');
  //   let isInCart = cartItems.some(item => item.id == varID);

  //   if (isInCart) {
  //     btn.classList.add('active');
  //   } else {
  //     btn.classList.remove('active');
  //   }
  // });
}





function addUpsellItem(variantID, button) {
  let formData = {
    id: variantID,
    quantity: 1
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (response.ok) {
      // Update button state
      // button.classList.add('active'); 
      // button.classList.remove('loading'); 
      checkUpsell();
    } else {
      console.error('Failed to add items to cart:', response);
      //button.classList.remove('loading'); 
    }
  })
  .catch((error) => {
    console.error('Error:', error);
     button.classList.remove('loading'); 
  });
}

function removeUpsellItem(variantID,qty) {
 
  let formData = {
    id: variantID,
    quantity: qty
  };

  console.log(formData);

  // Make the POST request to remove item from the cart
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (response.ok) {
      checkUpsell();
      console.log('Item successfully removed from cart');
    } else {
      console.error('Failed to remove item from cart:', response);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}





function addItem(variantID, button) {
  let formData = {
    id: variantID,
    quantity: 1
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (response.ok) {
      // Update button state
      //button.querySelector('.add-text').textContent = 'Added';
      button.disabled = true;
      button.classList.add('added'); 
      button.classList.remove('loading'); 
      loadKitItems();
    } else {
      console.error('Failed to add items to cart:', response);
       button.classList.remove('loading'); 
    }
  })
  .catch((error) => {
    console.error('Error:', error);
     button.classList.remove('loading'); 
  });
}

function addFirstSetItem(variantID, button) {
  let formData = {
    id: variantID,
    quantity: 1
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (response.ok) {
      // Update button state
      button.disabled = true;
      button.classList.add('added'); 
      button.classList.remove('loading'); 
      loadKitItems();
    } else {
      console.error('Failed to add items to cart:', response);
       button.classList.remove('loading'); 
    }
  })
  .catch((error) => {
    console.error('Error:', error);
     button.classList.remove('loading'); 
  });
}


function removeItem(variantID,qty) {
  let formData = {
    id: variantID,
    quantity: qty
  };

  console.log(formData);

  // Make the POST request to remove item from the cart
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (response.ok) {
      checkFirstSet();
      loadKitItems();
      console.log('Item successfully removed from cart');
    } else {
      console.error('Failed to remove item from cart:', response);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}


document.querySelectorAll('[data-checkout-pack]').forEach(element => {
  element.addEventListener('click', (event) => {
    event.preventDefault();       // Stop link/button default behavior
    event.stopPropagation();      // Stop event from bubbling up

    // Open Rebuy Smart Cart
    if (window.Rebuy?.SmartCart?.show) {
      window.Rebuy.SmartCart.show();
    } else {
      window.location.href = '/checkout';
      console.warn('Rebuy Smart Cart not available');
    }
  });
});




